
import React, {useEffect, useState, useMemo} from "react";
import '../Home/Home.css';
import SelectableBlockRoom from "../SelectableBlockRoom/SelectableBlockRoom";
import {useSelection} from "../../SelectionContext";
import {useNavigation} from "../../NavigationContext";
import Translate from "../../Translate";

export default function Room({setCurrentIndex,selectedCity}) {

    const { selection, updateSelection } = useSelection({room: null});
    const { setNextEnabled } = useNavigation();

    const options = useMemo(() => {
        switch (selectedCity) {
            case "Tallinn":
                return [
                    { title: <Translate id="FullComplect"/>, titleAdditional: <Translate id="FullComplectDescription"/>, timer: 1, typeTime: "h" },
                    { title: <Translate id="FirstPart"/>, titleAdditional: <Translate id="FirstPartDescription"/>,timer:30,typeTime: "min" },
                    { title: <Translate id="SecondPart"/>, titleAdditional: <Translate id="SecondPartDescription"/>, timer:30,typeTime: "min"}
                ];
            case "Tartu":
                return [
                    { title: <Translate id="FullComplect"/>, titleAdditional: <Translate id="FullComplectDescription"/>, timer: 1, typeTime: "h" },
                    { title: <Translate id="FirstPart"/>, titleAdditional: <Translate id="FirstPartDescription"/>,timer:30,typeTime: "min" },
                    { title: <Translate id="SecondPart"/>, titleAdditional: <Translate id="SecondPartDescription"/>, timer:30,typeTime: "min"}
                ];
            case "Toila":
                return [
                    { title: <Translate id="FullComplect"/>, titleAdditional: <Translate id="FullComplectDescription"/>, timer: 1, typeTime: "h" },
                    { title: <Translate id="FirstPart"/>, titleAdditional: <Translate id="FirstPartDescription"/>,timer:30,typeTime: "min" },
                    { title: <Translate id="SecondPart"/>, titleAdditional: <Translate id="SecondPartDescription"/>, timer:30,typeTime: "min"}
                ];
            default:
                return [];
        }
    }, [selectedCity]);
    const handleSelect = (room) => {
        updateSelection("room", room);
        setCurrentIndex((prev) => prev + 1);  // Переход на следующий слайд
    };

    useEffect(() => {
        setNextEnabled(!!selection.room);  // Разрешаем "Next" только если есть выбор
    }, [selection.room, setNextEnabled]);

    return (
        <div className="home-container">
            <div className="home-container">
                <div className="blocks-container">
                    {options.map((option) => (
                        <SelectableBlockRoom
                            key={typeof option.title === "string" ? option.title : option.title.props.id}
                            title={option.title}
                            titleAdditional={option.titleAdditional}
                            setTypeTimer={option.typeTime}
                            setTimer={option.timer}
                            isSelected={selection.room === option.title}
                            onSelect={() => handleSelect(option.title)}
                        />
                    ))}
                    </div>
                </div>

            {/*{selection.room && (*/}
            {/*    <div className="selected-info">*/}
            {/*        <p><Translate id="ChooseTown"/><strong>{selection.room}</strong></p>*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    )
}